import React from 'react';

export const AccoladeGallery = ({ one = {}, alumnuData, page = true, onClick, active }) => {

  // const grand = one.title ? one.title.search('Grand') !== -1 : false;
  const grand = one.grand;

  const BOT = 'https://a.storyblok.com/f/122726/720x720/c1b460bbc9/best-of-term-winner.png'

  const title = `${one.title ? one.title : ''} `;
  const title2 = `Best of Term Winner`;



  return <div className={`accolade_gallery0 ${page ? 'accolade_gallery0_page _backzoom0' : ''} ${active ? 'accolade_gallery0_active' : ''} ${grand ? 'accolade_gallery0_grand' : ''}`}
    onClick={onClick}
  >


    {page &&
      <div
        className='accolade_gallery_thumb '
        style={{ backgroundImage: `url(${one.thumbnail}/m/300x150)` }}
      />}


    {page && <AccoladeGalleryActive active={active} />}


    <div
      key={`accolade_gallery_${one._id}_${alumnuData._id}`}
      className={`accolade_gallery  ${grand ? 'accolade_gallery_grand' : ''} ${page ? 'accolade_gallery_page' : ''}`}
      // style={{ backgroundImage: `url(${one.thumbnail})` }} />
      style={{ backgroundImage: `url(${BOT})` }} />
    {page && <div className={`accolade_gallery_page_title ${grand ? 'accolade_gallery_page_title_grand' : ''}`}>{title} {title2}</div>}
    {page && one.category && <div className={`accolade_gallery_category`}>{one.category}</div>}
  </div>
};




export const AccoladeGalleryActive = ({ active }) => {
  return <>
    {active && <div className='accolade_gallery_active_inner' />}
    <div className='accolade_gallery_thumb accolade_gallery_thumb_active '>
      {active && <div className="accolade_gallery_active">
      </div>}
    </div>
  </>
}